import { TableName } from './tableName.enum';

export const PresenceFeeFunctions = {
  [TableName.Club]: 'feeClubList',
  [TableName.Team]: 'feeTeamList'
};
